import React from "react";
import { socialMediaLinks } from "../../design2/AnnouncementPostPage2";
import { formatDate } from "src/app/lib/formatDate";
import CardGrid from "src/app/components/CardGrid";
import { CommentType } from "src/app/components/constants/mockPosts";
import Comment3 from "../components/Comment3";
// import Link from "next/link";
import SimilarPosts3 from "../components/SimilarPosts3";
import { CardVariant3 } from "../../design2/components/CardVariant2";
import BackBtn from "../components/BackBtn3";
import StyledWraper from "../components/StyledWraper";
import Button from "src/app/components/ui/Button";
import { Post, PropertyType } from "src/types";
import PostMediaCarousel from "../../design1/components/PostMediaCarousel";
import { handleShareClick } from "src/app/components/constants/helperClient";
const AnnouncementPostPage3 = ({
  post,
  listings,
}: {
  post: Post;
  listings: PropertyType[];
}) => {
  return (
    <section className="pb-14 mt-10">
      <div className="wrapper flex flex-col gap-3">
        <div className="grid-container">
          <FirstCol mockPost={post} />
          <SecondCol properties={listings} />
        </div>
        <div className="">
          <SimilarPosts3 secondary arr={post.similar} />
        </div>
      </div>
    </section>
  );
};
export default AnnouncementPostPage3;
const FirstCol = ({ mockPost }: { mockPost: Post }) => {
  return (
    <div className="">
      <div className=" relative mb-8">
        <span className="absolute z-[100] top-4 left-4">
          <BackBtn />
        </span>
        <PostMediaCarousel post={mockPost} />
      </div>
      <div className="text-themeColor relative -left-3 divide-x divide-themeColor items-center flex-wrap mt-5 flex">
        <span className="flex px-3 text-white gap-2 items-center">
          <PersonIcon />{" "}
          <h1 className="text-themeColor text-base !font-normal whitespace-nowrap">
            {mockPost.author.name}
          </h1>
        </span>

        <div className="item px-3 flex gap-2">
          <CalendarIcon />{" "}
          <span className="whitespace-nowrap">{formatDate(mockPost.date)}</span>
        </div>

        <div className="group px-3 flex gap-3">
          <div className="item flex gap-2">
            <CommentIcon />{" "}
            <span className="whitespace-nowrap">
              {mockPost?.comments?.length} Comments
            </span>
          </div>
        </div>
      </div>

      <h1 className="my-6 h2">{mockPost.title}</h1>
      <div className="content mb-14">
        <div
          className="flex flex-col gap-2"
          dangerouslySetInnerHTML={{ __html: mockPost.content }}
        />
      </div>

      <div className="share  items-center flex justify-between pb-4 border-b border-b-themeColor mb-4">
        <div className="ites items-center flex gap-2">
          <StatItem icon={LikeIcon} number={mockPost.likes} />
          <StatItem icon={DislikeIcon} number={mockPost.dislikes} />
        </div>
        <div className="icons  flex items-center gap-2">
          {socialMediaLinks.map((item, index) => {
            return (
              <div
                onClick={() => handleShareClick(item.name)}
                className="grid cursor-pointer place-items-center"
                key={index}
              >
                {item.icon}
              </div>
            );
          })}
        </div>
      </div>
      <CommentsList comments={mockPost.comments} />
    </div>
  );
};
const SecondCol = ({ properties }: { properties: PropertyType[] }) => {
  if (properties.length === 0) {
    return <div>No properties available</div>;
  }
  return (
    <div className="!sticky !max-h-[1200px] overflow-scroll scrollbar-hide top-[80px]">
      <StyledWraper className="!bg-white   rounded-2xl">
        <div className=" p-2 max-h-[1200px]  bg-white  rounded-2xl  pt-0 child shadow-md">
          <div className="item  rounded-2xl z-[100] pt-6 bg-white flex justify-between">
            <h4 className="text-secondary-main font-semibold mb-4">
              Recent Listings
            </h4>

            <Button
              variant="new"
              className="text-themeColor h-max"
              href="/properties"
            >
              See More
            </Button>
          </div>
          <CardGrid
            className="divide-y rounded-2xl  divide-y-themeColor"
            maxColumns={1}
          >
            {properties.map((item, index) => {
              return (
                <div key={index} className="pt-4">
                  <CardVariant3 {...item} />
                </div>
              );
            })}
          </CardGrid>
        </div>
      </StyledWraper>
    </div>
  );
};
const PersonIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="var(--primary-color)" />
      <path
        d="M12.0002 7.19922C12.6367 7.19922 13.2472 7.45208 13.6973 7.90216C14.1473 8.35225 14.4002 8.9627 14.4002 9.59922C14.4002 10.2357 14.1473 10.8462 13.6973 11.2963C13.2472 11.7464 12.6367 11.9992 12.0002 11.9992C11.3637 11.9992 10.7532 11.7464 10.3031 11.2963C9.85305 10.8462 9.6002 10.2357 9.6002 9.59922C9.6002 8.9627 9.85305 8.35225 10.3031 7.90216C10.7532 7.45208 11.3637 7.19922 12.0002 7.19922ZM12.0002 16.7992C12.0002 16.7992 16.8002 16.7992 16.8002 15.5992C16.8002 14.1592 14.4602 12.5992 12.0002 12.5992C9.5402 12.5992 7.2002 14.1592 7.2002 15.5992C7.2002 16.7992 12.0002 16.7992 12.0002 16.7992Z"
        fill="currentColor"
      />
    </svg>
  );
};
const LikeIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 21.5H5V8.5H4C3.46957 8.5 2.96086 8.71071 2.58579 9.08579C2.21071 9.46086 2 9.96957 2 10.5V19.5C2 20.0304 2.21071 20.5391 2.58579 20.9142C2.96086 21.2893 3.46957 21.5 4 21.5ZM20 8.5H13L14.122 5.132C14.2221 4.83141 14.2494 4.51135 14.2016 4.19815C14.1538 3.88496 14.0322 3.58761 13.847 3.33059C13.6617 3.07358 13.4181 2.86424 13.1361 2.71984C12.8541 2.57543 12.5418 2.50008 12.225 2.5H12L7 7.938V21.5H18L21.912 12.904L22 12.5V10.5C22 9.96957 21.7893 9.46086 21.4142 9.08579C21.0391 8.71071 20.5304 8.5 20 8.5Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const CommentIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 10C19.7956 10 20.5587 10.3161 21.1213 10.8787C21.6839 11.4413 22 12.2044 22 13V16C22 16.7956 21.6839 17.5587 21.1213 18.1213C20.5587 18.6839 19.7956 19 19 19V19.966C19 21.026 17.764 21.605 16.95 20.926L14.638 19H12C11.2044 19 10.4413 18.6839 9.87868 18.1213C9.31607 17.5587 9 16.7956 9 16V13C9 12.2044 9.31607 11.4413 9.87868 10.8787C10.4413 10.3161 11.2044 10 12 10H19ZM16 4C16.7956 4 17.5587 4.31607 18.1213 4.87868C18.6839 5.44129 19 6.20435 19 7V8H11C9.93913 8 8.92172 8.42143 8.17157 9.17157C7.42143 9.92172 7 10.9391 7 12V16C7 17.044 7.4 17.996 8.056 18.708L7 19.5C6.176 20.118 5 19.53 5 18.5V17C4.20435 17 3.44129 16.6839 2.87868 16.1213C2.31607 15.5587 2 14.7956 2 14V7C2 6.20435 2.31607 5.44129 2.87868 4.87868C3.44129 4.31607 4.20435 4 5 4H16Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};

const DislikeIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 3.5H19V16.5H20C20.5304 16.5 21.0391 16.2893 21.4142 15.9142C21.7893 15.5391 22 15.0304 22 14.5V5.5C22 4.96957 21.7893 4.46086 21.4142 4.08579C21.0391 3.71071 20.5304 3.5 20 3.5ZM4 16.5H11L9.878 19.868C9.77789 20.1686 9.75061 20.4887 9.79843 20.8018C9.84624 21.115 9.96778 21.4124 10.153 21.6694C10.3383 21.9264 10.5819 22.1358 10.8639 22.2802C11.1459 22.4246 11.4582 22.4999 11.775 22.5H12L17 17.062V3.5H6L2.088 12.096L2 12.5V14.5C2 15.0304 2.21071 15.5391 2.58579 15.9142C2.96086 16.2893 3.46957 16.5 4 16.5Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const CommentsList = ({ comments }: { comments: CommentType[] }) => {
  return (
    <div className=" p-4 pl-0">
      {comments.length > 0 ? (
        comments.map((comment) => (
          <div
            key={comment.id}
            className=" pb-3 mb-4 border-b border-b-themeColor"
          >
            <Comment3 comment={comment} />
          </div>
        ))
      ) : (
        <p className="text-gray-500">No comments yet.</p>
      )}
    </div>
  );
};
interface StatItemProps {
  icon: React.FC; // Icon component (e.g., LikeIcon, EyeIcon)
  number: number | string; // The value to display (could be a number or formatted string)
  textClassName?: string; // Optional prop to customize text styling (e.g., for likes)
}
const StatItem: React.FC<StatItemProps> = ({
  icon: Icon,
  number,
  textClassName,
}) => {
  return (
    <div className="flex text-secondary-main gap-1">
      <Icon />
      <span className={textClassName || ""}>{number}</span>
    </div>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M21.998 6H18.998C17.672 6 16.4002 6.52678 15.4625 7.46447C14.5248 8.40215 13.998 9.67392 13.998 11V14H10.998V18H13.998V26H17.998V18H20.998L21.998 14H17.998V11C17.998 10.7348 18.1034 10.4804 18.2909 10.2929C18.4785 10.1054 18.7328 10 18.998 10H21.998V6Z"
        fill="white"
      />
    </svg>
  );
};
export const InstagramIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M20.166 7.66406H11.8327C9.5315 7.66406 7.66602 9.52954 7.66602 11.8307V20.1641C7.66602 22.4652 9.5315 24.3307 11.8327 24.3307H20.166C22.4672 24.3307 24.3327 22.4652 24.3327 20.1641V11.8307C24.3327 9.52954 22.4672 7.66406 20.166 7.66406Z"
        fill="white"
      />
      <path
        d="M19.3337 15.4772C19.4366 16.1707 19.3181 16.8791 18.9952 17.5014C18.6723 18.1237 18.1614 18.6284 17.5351 18.9436C16.9088 19.2588 16.1991 19.3685 15.5069 19.2571C14.8147 19.1458 14.1752 18.8189 13.6794 18.3232C13.1837 17.8274 12.8569 17.1879 12.7455 16.4957C12.6341 15.8035 12.7438 15.0938 13.059 14.4675C13.3742 13.8412 13.8789 13.3303 14.5012 13.0074C15.1236 12.6845 15.8319 12.566 16.5254 12.6689C17.2328 12.7738 17.8878 13.1034 18.3935 13.6091C18.8992 14.1148 19.2288 14.7698 19.3337 15.4772Z"
        stroke="var(--primary-color)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.584 11.4141H20.594"
        stroke="var(--primary-color)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const TwitterIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M23.5 7H8.5C8.10218 7 7.72064 7.15804 7.43934 7.43934C7.15804 7.72064 7 8.10218 7 8.5V23.5C7 23.8978 7.15804 24.2794 7.43934 24.5607C7.72064 24.842 8.10218 25 8.5 25H23.5C23.8978 25 24.2794 24.842 24.5607 24.5607C24.842 24.2794 25 23.8978 25 23.5V8.5C25 8.10218 24.842 7.72064 24.5607 7.43934C24.2794 7.15804 23.8978 7 23.5 7ZM21.0306 19.9694C21.1003 20.0391 21.1556 20.1218 21.1933 20.2128C21.231 20.3039 21.2504 20.4015 21.2504 20.5C21.2504 20.5985 21.231 20.6961 21.1933 20.7872C21.1556 20.8782 21.1003 20.9609 21.0306 21.0306C20.9609 21.1003 20.8782 21.1556 20.7872 21.1933C20.6961 21.231 20.5985 21.2504 20.5 21.2504C20.4015 21.2504 20.3039 21.231 20.2128 21.1933C20.1218 21.1556 20.0391 21.1003 19.9694 21.0306L16 17.0603L12.0306 21.0306C11.8899 21.1714 11.699 21.2504 11.5 21.2504C11.301 21.2504 11.1101 21.1714 10.9694 21.0306C10.8286 20.8899 10.7496 20.699 10.7496 20.5C10.7496 20.301 10.8286 20.1101 10.9694 19.9694L14.9397 16L10.9694 12.0306C10.8286 11.8899 10.7496 11.699 10.7496 11.5C10.7496 11.301 10.8286 11.1101 10.9694 10.9694C11.1101 10.8286 11.301 10.7496 11.5 10.7496C11.699 10.7496 11.8899 10.8286 12.0306 10.9694L16 14.9397L19.9694 10.9694C20.1101 10.8286 20.301 10.7496 20.5 10.7496C20.699 10.7496 20.8899 10.8286 21.0306 10.9694C21.1714 11.1101 21.2504 11.301 21.2504 11.5C21.2504 11.699 21.1714 11.8899 21.0306 12.0306L17.0603 16L21.0306 19.9694Z"
        fill="white"
      />
    </svg>
  );
};
export const YoutubeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M24.7845 11.3526C24.6855 10.9571 24.4839 10.5947 24.2 10.3021C23.9161 10.0095 23.5601 9.79692 23.1678 9.68594C21.7345 9.33594 16.0011 9.33594 16.0011 9.33594C16.0011 9.33594 10.2678 9.33594 8.83446 9.71927C8.44217 9.83026 8.08611 10.0428 7.80225 10.3354C7.51839 10.6281 7.31678 10.9904 7.21779 11.3859C6.95547 12.8406 6.82716 14.3162 6.83446 15.7943C6.82511 17.2835 6.95343 18.7704 7.21779 20.2359C7.32693 20.6191 7.53305 20.9677 7.81625 21.248C8.09945 21.5283 8.45014 21.7308 8.83446 21.8359C10.2678 22.2193 16.0011 22.2193 16.0011 22.2193C16.0011 22.2193 21.7345 22.2193 23.1678 21.8359C23.5601 21.7249 23.9161 21.5124 24.2 21.2198C24.4839 20.9271 24.6855 20.5648 24.7845 20.1693C25.0448 18.7256 25.1731 17.2612 25.1678 15.7943C25.1771 14.3051 25.0488 12.8182 24.7845 11.3526Z"
        fill="white"
      />
      <path
        d="M14.125 18.5164L18.9167 15.7914L14.125 13.0664V18.5164Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
export const TikTokIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="var(--primary-color)" />
      <path
        d="M20.0578 10.5067C19.4503 9.81291 19.1155 8.92213 19.1156 8H16.3689V19.0222C16.3481 19.6188 16.0965 20.1841 15.6669 20.5987C15.2374 21.0133 14.6636 21.2448 14.0667 21.2444C12.8044 21.2444 11.7556 20.2133 11.7556 18.9333C11.7556 17.4044 13.2311 16.2578 14.7511 16.7289V13.92C11.6844 13.5111 9 15.8933 9 18.9333C9 21.8933 11.4533 24 14.0578 24C16.8489 24 19.1156 21.7333 19.1156 18.9333V13.3422C20.2293 14.1421 21.5665 14.5712 22.9378 14.5689V11.8222C22.9378 11.8222 21.2667 11.9022 20.0578 10.5067Z"
        fill="white"
      />
    </svg>
  );
};

const CalendarIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.7501 2.5C7.7501 2.30109 7.67108 2.11032 7.53043 1.96967C7.38978 1.82902 7.19901 1.75 7.0001 1.75C6.80119 1.75 6.61042 1.82902 6.46977 1.96967C6.32912 2.11032 6.2501 2.30109 6.2501 2.5V4.08C4.8101 4.195 3.8661 4.477 3.1721 5.172C2.4771 5.866 2.1951 6.811 2.0791 8.25H21.9211C21.8051 6.81 21.5231 5.866 20.8281 5.172C20.1341 4.477 19.1891 4.195 17.7501 4.079V2.5C17.7501 2.30109 17.6711 2.11032 17.5304 1.96967C17.3898 1.82902 17.199 1.75 17.0001 1.75C16.8012 1.75 16.6104 1.82902 16.4698 1.96967C16.3291 2.11032 16.2501 2.30109 16.2501 2.5V4.013C15.5851 4 14.8391 4 14.0001 4H10.0001C9.1611 4 8.4151 4 7.7501 4.013V2.5Z"
        fill="var(--primary-color)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 12C2 11.161 2 10.415 2.013 9.75H21.987C22 10.415 22 11.161 22 12V14C22 17.771 22 19.657 20.828 20.828C19.656 21.999 17.771 22 14 22H10C6.229 22 4.343 22 3.172 20.828C2.001 19.656 2 17.771 2 14V12ZM17 14C17.2652 14 17.5196 13.8946 17.7071 13.7071C17.8946 13.5196 18 13.2652 18 13C18 12.7348 17.8946 12.4804 17.7071 12.2929C17.5196 12.1054 17.2652 12 17 12C16.7348 12 16.4804 12.1054 16.2929 12.2929C16.1054 12.4804 16 12.7348 16 13C16 13.2652 16.1054 13.5196 16.2929 13.7071C16.4804 13.8946 16.7348 14 17 14ZM17 18C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17C18 16.7348 17.8946 16.4804 17.7071 16.2929C17.5196 16.1054 17.2652 16 17 16C16.7348 16 16.4804 16.1054 16.2929 16.2929C16.1054 16.4804 16 16.7348 16 17C16 17.2652 16.1054 17.5196 16.2929 17.7071C16.4804 17.8946 16.7348 18 17 18ZM13 13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13C11 12.7348 11.1054 12.4804 11.2929 12.2929C11.4804 12.1054 11.7348 12 12 12C12.2652 12 12.5196 12.1054 12.7071 12.2929C12.8946 12.4804 13 12.7348 13 13ZM13 17C13 17.2652 12.8946 17.5196 12.7071 17.7071C12.5196 17.8946 12.2652 18 12 18C11.7348 18 11.4804 17.8946 11.2929 17.7071C11.1054 17.5196 11 17.2652 11 17C11 16.7348 11.1054 16.4804 11.2929 16.2929C11.4804 16.1054 11.7348 16 12 16C12.2652 16 12.5196 16.1054 12.7071 16.2929C12.8946 16.4804 13 16.7348 13 17ZM7 14C7.26522 14 7.51957 13.8946 7.70711 13.7071C7.89464 13.5196 8 13.2652 8 13C8 12.7348 7.89464 12.4804 7.70711 12.2929C7.51957 12.1054 7.26522 12 7 12C6.73478 12 6.48043 12.1054 6.29289 12.2929C6.10536 12.4804 6 12.7348 6 13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14ZM7 18C7.26522 18 7.51957 17.8946 7.70711 17.7071C7.89464 17.5196 8 17.2652 8 17C8 16.7348 7.89464 16.4804 7.70711 16.2929C7.51957 16.1054 7.26522 16 7 16C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
